import NewBoard from './NewBoard';

export * from './NewBoard';
export default NewBoard;
